import "./ArchiveMission.css";
import { useState, useEffect } from "react";
import gsap from "gsap";

const formatBackToHours = (timeSlot, baseHour = 8) => {
  const minutes = (timeSlot * 15) % 60;
  const hourOffset = Math.floor((timeSlot * 15) / 60);
  const hour = baseHour + hourOffset;

  return `${hour}h${minutes === 0 ? "00" : minutes}`;
};

const ArchiveMission = ({ mission }) => {
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const cards = document.querySelectorAll(".info-card");
    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        gsap.to(card, {
          "--shadow-spread": "6px",
          duration: 0.15,
          ease: "power1.inOut",
        });
      });
      card.addEventListener("mouseleave", () => {
        gsap.to(card, {
          "--shadow-spread": "4px",
          duration: 0.15,
          ease: "power1.inOut",
        });
      });
    });

    return () => {
      cards.forEach((card) => {
        card.removeEventListener("mouseenter", () => {});
        card.removeEventListener("mouseleave", () => {});
      });
    };
  }, []);

  return (
    <>
      <div className="archive-mission info-card">
        <p className="info-card-name">
          {mission.client_name}
        </p>
        <div className="info-card-name-underline"></div>
        <p className="info-card-label">Date</p>
        <p className="info-card-value">{mission.date}</p>
        <p className="info-card-label">Opération</p>
        <p className="info-card-value">{mission.operation}</p>
        <div className="info-card-buttons">
          <button onClick={() => setShowDetails(true)}>Voir les détails</button>
        </div>
      </div>
      
      {showDetails && (
        <div className="popup-container" onClick={() => setShowDetails(false)}>
          <div className="mission-details-popup" onClick={(e) => e.stopPropagation()}>
            <h2>Détails de la mission</h2>
            <div className="mission-details-content">
              <div className="detail-group">
                <label>Client:</label>
                <p>{mission.client_name}</p>
              </div>
              <div className="detail-group">
                <label>Agent:</label>
                <p>{mission.agent_name}</p>
              </div>
              <div className="detail-group">
                <label>Date:</label>
                <p>{mission.date}</p>
              </div>
              <div className="detail-group">
                <label>Horaires:</label>
                <p>{formatBackToHours(mission.beginning)} - {formatBackToHours(mission.ending)}</p>
              </div>
              <div className="detail-group">
                <label>Adresse:</label>
                <p>{mission.adresse}</p>
              </div>
              <div className="detail-group">
                <label>Opération:</label>
                <p>{mission.operation}</p>
              </div>
              {mission.notes && (
                <div className="detail-group">
                  <label>Notes:</label>
                  <p>{mission.notes}</p>
                </div>
              )}
            </div>
            <button className="close-button" onClick={() => setShowDetails(false)}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ArchiveMission;
